import React, { useState } from "react";
import { Office, Availability } from "./OfficesManager";
import { useParams, useNavigate, useSearchParams } from "react-router-dom";

interface OfficesHoursListProps {
  offices: Office[];
  onEditHours: (officeId: string) => void;
  onToggleStatus: (officeId: string, currentStatus: boolean) => void;
}

const OfficesHoursList: React.FC<OfficesHoursListProps> = ({
  offices,
  onEditHours,
  onToggleStatus,
}) => {
  const [statusFilter, setStatusFilter] = useState<string>("all");
  const navigate = useNavigate();

  const handleAddSchedule = () => {
    navigate("/offices/availability");
  };
  const filteredOffices = offices.filter((office) => {
    if (statusFilter === "all") return true;
    const isActive = office.availability && office.availability.length > 0;
    return statusFilter === "active" ? isActive : !isActive;
  });

  const getDayName = (dayOfWeek: number): string => {
    const days = [
      "Lunes",
      "Martes",
      "Miércoles",
      "Jueves",
      "Viernes",
      "Sábado",
      "Domingo",
    ];
    return days[dayOfWeek];
  };

  const formatTime = (timeString: string): string => {
    const [hours, minutes] = timeString.split(":");
    const hour = parseInt(hours);
    const period = hour >= 12 ? "PM" : "AM";
    const formattedHour = hour % 12 || 12;
    return `${formattedHour}:${minutes} ${period}`;
  };

  const getOfficeHoursByDay = (office: Office) => {
    const days = [0, 1, 2, 3, 4, 5, 6]; // Monday to Sunday
    return days.map((day) => {
      const availability = office.availability.find(
        (avail) => avail.day_of_week === day
      );
      return {
        day,
        availability,
      };
    });
  };

  const isOfficeActive = (office: Office): boolean => {
    return office.availability && office.availability.length > 0;
  };

  return (
    <div className="offices-hours-list">
      <div className="filters">
        <div className="filter-group">
          <label htmlFor="office-hours-status-filter">Filtrar por Estado</label>
          <select
            id="office-hours-status-filter"
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
          >
            <option value="all">Todos los estados</option>
            <option value="active">Activos</option>
            <option value="inactive">Inactivos</option>
          </select>
        </div>
        <div className="filter-group">
          <label>&nbsp;</label>
          {/* <button className="btn btn--primary" onClick={handleAddSchedule}>
            Gestionar Horarios
          </button> */}
        </div>
      </div>

      <div className="office-hours-grid">
        {filteredOffices.map((office) => {
          const officeHours = getOfficeHoursByDay(office);

          return (
            <div
              key={office.id}
              className="office-hours-card"
              data-status={isOfficeActive(office) ? "active" : "inactive"}
            >
              <div className="office-hours-card__header">
                <h3 className="office-hours-card__title">{office.name}</h3>
                <span
                  className={`status-badge ${
                    isOfficeActive(office)
                      ? "status-badge--active"
                      : "status-badge--inactive"
                  }`}
                >
                  {isOfficeActive(office) ? "Activo" : "Inactivo"}
                </span>
              </div>
              <div className="office-hours-card__body">
                <div className="office-hours-card__schedule">
                  {officeHours.map(({ day, availability }) => (
                    <div key={day} className="office-hours-card__day">
                      <div className="office-hours-card__day-header">
                        <span className="office-hours-card__day-name">
                          {getDayName(day)}
                        </span>
                        <div className="office-hours-card__day-hours">
                          {availability ? (
                            <>
                              <span className="office-hours-card__hours">
                                {formatTime(availability.start_time)} -{" "}
                                {formatTime(availability.end_time)}
                              </span>
                              <i className="fas fa-clock office-card__detail-icon icon-primary"></i>
                            </>
                          ) : (
                            <span className="office-hours-card__closed">
                              Cerrado
                            </span>
                          )}
                        </div>
                      </div>
                      {availability &&
                        availability.break_start_time &&
                        availability.break_end_time && (
                          <div className="office-hours-card__break">
                            <i className="fas fa-coffee office-hours-card__break-icon"></i>
                            <span>
                              Descanso:{" "}
                              {formatTime(availability.break_start_time)} -{" "}
                              {formatTime(availability.break_end_time)}
                            </span>
                          </div>
                        )}
                    </div>
                  ))}
                </div>
              </div>
              <div className="office-hours-card__footer">
                <div className="office-hours-card__actions">
                  <button
                    className="btn btn--secondary"
                    onClick={() => onEditHours(office.id)}
                  >
                    Editar Horarios
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {filteredOffices.length === 0 && (
        <div className="empty-state">
          <div className="empty-state__icon">
            <i className="fas fa-clock"></i>
          </div>
          <h3>No se encontraron horarios</h3>
          <p>
            No hay horarios de oficina que coincidan con los filtros aplicados.
          </p>
        </div>
      )}
    </div>
  );
};

export default OfficesHoursList;
